type DownloadOptions = {
  fileName?: string;
};

const defaultFileName = (countySlug: string) => `rentsmart-housing-report-${countySlug}.pdf`;

export const downloadHousingReportPdf = (
  countySlug: string,
  options: DownloadOptions = {}
): void => {
  const fileName = options.fileName || defaultFileName(countySlug);
  const originalTitle = document.title;

  const restoreTitle = () => {
    document.title = originalTitle;
    window.removeEventListener('afterprint', restoreTitle);
  };

  document.title = fileName.replace(/\.pdf$/i, '');
  window.addEventListener('afterprint', restoreTitle);
  window.print();
};

export const printHousingReport = (): void => {
  window.print();
};
